// Frontend auto-refresh, mirroring the main app: the API serves the members-app version (App/version_members.json
// via GET members/version); whenever the served version differs from the one this browser last saw, we hard-reload
// so members always run the freshly deployed frontend. The very first version we see is just remembered — there is
// nothing stale to reload yet.
import api from './api.js';

const VERSION_KEY = 'fytlix_members_version';

export async function checkVersion() {
    const response = await api.get('version', null, { client: false, loader: false });
    if (!response.success || !response.data || response.data.version === undefined || response.data.version === null) {
        return;
    }

    const current = String(response.data.version);
    const stored = localStorage.getItem(VERSION_KEY);
    localStorage.setItem(VERSION_KEY, current);

    if (stored !== null && stored !== current) {
        window.location.reload(true);
    }
}
